module.exports = __webpack_public_path__ + "img/active.c05f98d6.svg";